import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import cx from 'classnames';
import { colors } from '../../styles';

export interface Props {
  className?: string;
  items: PillsMenuItem[];
  onClick?: (args?: any) => void;
  onFocus?: (args?: any) => void;
  direction?: 'column' | 'row';
  active?: string;
}

export interface State {
  focusedItem?: object;
  onClick?: any;
}

export interface PillsMenuItem {
  id: string;
  component?: JSX.Element | React.ReactNode | string;
  onClick?: () => void;
}

class PillsMenu extends React.Component<Props, State> {
  onFocus = ({ item, onItemClick }) => {
    this.setState({
      focusedItem: item,
      onClick: onItemClick,
    });
    const { onFocus } = this.props;
    onFocus && onFocus(item);
  };
  onKeyPress = event => {
    event.preventDefault();
    if (event.key === 'Enter') {
      const { focusedItem, onClick } = this.state;
      if (focusedItem && onClick) {
        onClick(focusedItem);
      }
    }
  };
  render() {
    const { className, items, onClick, direction, active } = this.props;
    return (
      <div
        className={`${className} ${direction || 'row'}`}
        onKeyPress={this.onKeyPress}
      >
        {items &&
          items.map((item: PillsMenuItem) => {
            const onItemClick =
              (item.onClick && item.onClick.bind(item)) ||
              (onClick && onClick.bind(null, item));
            return (
              <div
                tabIndex={0}
                onFocus={this.onFocus.bind(null, { item, onItemClick })}
                key={item.id}
                className={cx('pills-menu-item', {
                  active: active === item.id,
                })}
                onClick={onItemClick}
              >
                <div>{item.component}</div>
              </div>
            );
          })}
      </div>
    );
  }
}

export default styled(PillsMenu)`
  display: flex;
  flex-flow: ${props => props.direction || 'row'};
  .pills-menu-item {
    width: ${props => 100 / props.items.length + '%'};
    padding: 0.5rem;
    text-align: center;
    border: 1px solid ${colors.grey500};
    cursor: pointer;
    transition: all 0.2s ease;
  }
  .pills-menu-item.active {
    background-color: ${colors.green10};
    color: ${colors.green500};
    transition: all 0.2s ease;
  }
  .pills-menu-item:focus {
    outline: ${colors.green200} auto 3px;
    transition: all 0.2s ease;
  }
  &.row > .pills-menu-item {
    border-left: 0.5px solid ${colors.grey500};
    border-right: 0.25px solid ${colors.grey500};
  }
  &.row > .pills-menu-item:last-child {
    border-right: 0.5px solid ${colors.grey500};
  }
`;
